import { makeStyles } from '@material-ui/core/styles';
import { input } from 'UI/constants/dimensions';

export const useStyles = makeStyles(theme => ({
  root: {
    ...theme.input,
    margin: 'unset',
    height: 'unset',
    width: '100%',
    '& .MuiOutlinedInput-root:not(.MuiOutlinedInput-multiline)': {
      height: input.height
    },
    '& .MuiOutlinedInput-input': {
      boxSizing: 'border-box',
      height: '100%',
      paddingTop: 0,
      paddingBottom: 0
    }
  }
}));
